import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { HttpErrorResponse } from "@angular/common/http";
import { Observable, Subject } from 'rxjs';

import { SubjectRelay } from '../../../../shared/commands/subject-relay.class';
import { DocumentPersonneAvertieResult } from "../../entities/document-personne-avertie-result";
import { DocumentPaUrlUpdateOrder } from "../../entities/document-pa-url-update-order.entity";

import { DocumentPaService } from "../../services/document-pa-service";

@Component({
	selector: 'pa-manage-link',
	templateUrl: 'pa-manage-link.html',
	styleUrls: ['pa-manage-link.css'],
})
export class PaManageLinkComponent {
	
	// Gestion globale de la fenetre
	displaySubject = new Subject<boolean>();
	personneAvertie!: DocumentPersonneAvertieResult;
	link: string = '';
	
	urlPattern = '^(https?:\\/\\/)?' + '(([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,})' + '(\\:[0-9]{1,5})?' + '(\\/.*)?$';
		
	waitingForServer: boolean = false;
	
	constructor(@Inject(DocumentPaService) private documentPaService: DocumentPaService) {
		this.manageCommandsSubject.subscribe(
			(data) => {
				// faire les affectations puis afficher la fenetre
				this.waitingForServer = false;
				this.personneAvertie = data;
				this.link = data.lien ?? '';
				this.displaySubject.next(true);
			}
 		);
	}

	@Input() id = 'paManageLinkDialog';
	
	// Liaison de l'observable servant a commander l'affichage du composant
	private manageCommandsSubject = new SubjectRelay<DocumentPersonneAvertieResult>();
	@Input() set manageCommands(obs: Observable<DocumentPersonneAvertieResult> | undefined) {
		this.manageCommandsSubject.registerSource(obs);
	}

	// Evenements de changement sur le pdp
	@Output() paChanged = new EventEmitter<number>();
	
	onCloseRequested() {
		this.cleanAndClose();
	}
	
	private cleanAndClose(): void {
		this.displaySubject.next(false);
		if (this.personneAvertie) {
			this.paChanged.emit(this.personneAvertie.id);
		}
	}
	
	onSaveRequested() {
		if (this.link && !new RegExp(this.urlPattern).test(this.link)) {
			return;
		}

		this.waitingForServer = true;

		const command: DocumentPaUrlUpdateOrder = {
			id: this.personneAvertie.id,
			url: this.link ?? ''
		};

		this.documentPaService.addUrl(command).subscribe({
			next: () => {
				this.waitingForServer = false;
				this.cleanAndClose();
			},
			error: (err: HttpErrorResponse) => {
				this.waitingForServer = false;
				console.error(err);
			}
		});
	}
}